// import react libraries
import React, { useState } from "react";
import { usePagination, DOTS } from "../Common/Table/usePagination";
import { useTranslation } from "react-i18next";

const NewsPagination = (props) => {
    // translation
    const { t } = useTranslation();
    const {
        onPageChange,
        totalCount,
        siblingCount = 1,
        currentPage,
        pageSize,
    } = props;

    const paginationRange = usePagination({
        currentPage,
        totalCount,
        siblingCount,
        pageSize
    });

    if (currentPage === 0 || paginationRange.length < 2) {
        return null;
    }

    const onNext = () => {
        onPageChange(currentPage + 1);
    };

    const onPrevious = () => {
        onPageChange(currentPage - 1);
    };

    let lastPage = paginationRange[paginationRange.length - 1];

    return (
        <nav className="flex text-xs justify-between items-center w-full flex-column flex-wrap md:flex-row relative space-x-3" aria-label="Table navigation">
            <div className="font-normal text-light-400 capitalize">{ t("showing") } {currentPage === 1 ? currentPage : ((currentPage-1)*pageSize)+1} { t('to') } {currentPage*pageSize} { t('of') } {totalCount} { t('entries') }</div>
            <ul className="space-x-3 flex items-center justify-between" >
                <li key="prev" className={currentPage === 1 ? 'cursor-not-allowed' : 'cursor-pointer'} onClick={currentPage === 1 ? null : onPrevious}>
                    <div>
                        { currentPage === 1 
                            ? 
                                <img src="../../../assets/icons/table/left-arrow-disable.svg" alt="left-arrow-disable" />
                            : 
                                <img src="../../../assets/icons/table/left-arrow-active.svg" alt="left-arrow-active" />
                        }
                    </div>
                </li>
                <div>
                    <ul className="flex items-center justify-between space-x-3">
                        {paginationRange.map((pageNumber, index) => {
                            if (pageNumber === DOTS) {
                                return <li className="cursor-pointer" key={`pag`+index}>&#8230;</li>;
                            }
                            return (
                                <li key={`pag`+index} className={(pageNumber === currentPage ? 'border-blue-normal bg-blue-normal text-white' : 'border-black-100 bg-white text-light-400') +" rounded border py-1 px-2 text-center cursor-pointer"} onClick={() => onPageChange(pageNumber)}>
                                    {pageNumber}
                                </li>
                            );
                        })}
                    </ul>
                </div>
                <li key="next" className={currentPage === lastPage ? 'cursor-not-allowed' : 'cursor-pointer'} onClick={currentPage === lastPage ? null : onNext}>
                    <div>
                        { currentPage === lastPage
                            ? 
                                <img src="../../../assets/icons/table/right-arrow-disable.svg" alt="right-arrow-disable" />
                            : 
                                <img src="../../../assets/icons/table/right-arrow-active.svg" alt="right-arrow-active" />
                        }
                    </div>
                </li>
            </ul>
        </nav>
    );
};

export default NewsPagination;